<template>
  <v-card
    class="mx-auto"
    max-width="360"
    style="box-shadow: none; background-color: #f4f4f4"
  >
    <v-card-text>
      <div class="text-center ml-1">
        <img
          src="https://esfasil.com/wp-content/uploads/2022/09/fasil-logo.svg"
          width="130"
        />
      </div>
      <p
        style="font-size: 20px; margin-top: 15px; margin-bottom: 15px"
        class="text-center"
      >
        ¡Lo sentimos! Ha ocurrido un error, por favor inténtalo de nuevo.
      </p>
    </v-card-text>
    <v-card-actions>
      <div class="row justify-center align-center">
        <v-btn
          class="mb-1 text-capitalize"
          rounded
          color="#ffb300"
          dark
          @click="onRetry"
        >
          Reintentar
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "Error",
  data: () => ({
    reveal: false,
  }),
  methods: {
    onRetry() {
      this.$emit("retry", true);
    },
  },
};
</script>
